import { writable } from "svelte/store";

const selectedPostData = writable(undefined);

// contains post data for the selected post
export { selectedPostData }